import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SearchTypes, getSearchType } from '@app/e-ticket-emd-select/container/e-ticket-emd-select-cont.component';
import { ServicingBaseComponent } from '@common/components';
import { PREVIOUS_PAGE_IDENTIFIER } from '@common/interfaces';
import { ServicingCommonStoreService } from '@common/services';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { environment } from '@env/environment';
import { CommonLibService } from '@lib/services';

/**
 * 別SPAに遷移する際に指定するCONNECTION_KIND
 * key:クエリパラメータに指定するためのキー
 * value：実際に指定するCONNECTION_KINDの値
 */
export const CONNECTION_KIND_OTHER_SPA_TRANSITION = {
  CONNECTION_KIND: 'ZZZ',
};

@Component({
  selector: 'asw-e-ticket-emd-select-sub-header',
  templateUrl: './e-ticket-emd-select-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ETicketEmdSelectSubHeaderComponent extends ServicingBaseComponent {
  /** 戻るボタン押下時の遷移先URL */
  backUrl: string = SERVICING_ROUTES.emdSearch;
  pagetitleMessageId: string = 'm_static_message-label.document.showOrPrint';
  isBackToEmdSearch: boolean = false;
  isBackToAnotherApp: boolean = false;

  constructor(private servicingCommonStoreService: ServicingCommonStoreService, _commonLibService: CommonLibService) {
    super(_commonLibService);
  }

  override init(): void {
    const reservationDetailPreviousPage =
      this.servicingCommonStoreService.servicingCommon.reservationDetailPreviousPage;
    const nextAcction = this.servicingCommonStoreService.servicingCommon.nextAction;
    const isReservationDetailPreviousPageMatch = (functionId: string, pageId: string) => {
      return (
        reservationDetailPreviousPage?.functionId === functionId && reservationDetailPreviousPage?.pageId === pageId
      );
    };

    // 当画面への遷移経路をもとに戻るボタン押下時の遷移先URLを判定する
    if (isReservationDetailPreviousPageMatch('C01', 'P050') && nextAcction) {
      // チェックイン確認: 他アプリの場合、遷移先URLとしてルートからのパスを設定する。また、CONNECTION_KIND=ZZZをクエリパラメータとして設定する(S2パーソナライズ情報を更新させないようにする目的)。
      this.backUrl = `${environment.spa.baseUrl}${environment.spa.app.cki}/${SERVICING_ROUTES.checkinReview}`;
      const backUrlQueryParams = new URLSearchParams(CONNECTION_KIND_OTHER_SPA_TRANSITION).toString();
      this.backUrl += `?${backUrlQueryParams}`;
      this.isBackToAnotherApp = true;
    } else if (isReservationDetailPreviousPageMatch('C02', 'P010') && nextAcction) {
      // チェックイン状況詳細: 他アプリの場合、遷移先URLとしてルートからのパスを設定する。また、CONNECTION_KIND=ZZZをクエリパラメータとして設定する(S2パーソナライズ情報を更新させないようにする目的)。
      this.backUrl = `${environment.spa.baseUrl}${environment.spa.app.cki}/${SERVICING_ROUTES.checkinMybooking}`;
      const backUrlQueryParams = new URLSearchParams(CONNECTION_KIND_OTHER_SPA_TRANSITION).toString();
      this.backUrl += `?${backUrlQueryParams}`;
      this.isBackToAnotherApp = true;
    } else if (
      this.servicingCommonStoreService.servicingCommon.previousPageIdentifier === PREVIOUS_PAGE_IDENTIFIER.EMD_SEARCH
    ) {
      // EMD検索
      this.backUrl = SERVICING_ROUTES.emdSearch;
      this.isBackToEmdSearch = true;
    } else {
      // 予約詳細
      this.backUrl = SERVICING_ROUTES.myBooking;
    }

    const searchType = getSearchType(this.servicingCommonStoreService.servicingCommon.previousPageIdentifier);
    if (searchType === SearchTypes.EMD_1) {
      this.pagetitleMessageId = 'm_static_message-label.emdList';
    } else {
      this.pagetitleMessageId = 'm_static_message-label.document.showOrPrint';
    }
  }
  override reload(): void {}
  override destroy(): void {}

  goBack(): void {
    if (this.isBackToEmdSearch) {
      // EMD検索(S05-P030)へ遷移するときは、遷移時にEMD検索画面表示フラグをtrueに設定する。
      this.servicingCommonStoreService.updateServicingCommon({
        emdSearchDisplayFlag: true,
      });
    }
  }
}
